var Viewport = require("ott/image-viewer/Viewport"),
    get      = require("object-path").get,
    kind     = require("enyo/kind");

module.exports = kind(/** @lends app.MediaPlayer.Tech.ImageViewer.CanvasView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.Tech.ImageViewer.CanvasView",

    /**
     * @private
     */
    kind: Viewport,

    /**
     * @private
     */
    classes: "image-viewer",

    /**
     * No transparency, for speed.
     *
     * @type {?Object}
     * @public
     */
    rendererOptions: {
        alpha: false
    },

    /**
     * The dataset containing the image.
     *
     * @type {?Array}
     * @public
     */
    data: null,

    /**
     * @private
     */
    handlers: {
        oncontextmenu: "onContextMenu"
    },

    /**
     * Prevent right-click menu.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The event
     * @returns  {boolean}       Whether to stop event propagation.
     * @private
     */
    onContextMenu: function(sender, event) {
        event.preventDefault();

        return false;
    },

    /**
     * Retrieves a unique identifier from the dataset.
     *
     * @param    {*}       data  The data
     * @return   {string}  The data uid.
     * @memberof app.MediaPlayer.Tech.ImageViewer.CanvasView
     * @private
     */
    getDataUid: function(data) {
        return data.id;
    },

    /**
     * Determines if a previous image is available.
     *
     * @return {boolean} Whether a previous image is available.
     * @abstract
     * @protected
     */
    hasPreviousImage: function() {
        var watchingSession = this.watchingSession;

        return get(watchingSession, "prev.type", null) === "photo";
    },

    /**
     * Determines if a next image is available.
     *
     * @return {boolean} Whether a next image is available.
     * @abstract
     * @protected
     */
    hasNextImage: function() {
        var watchingSession = this.watchingSession;

        return get(watchingSession, "next.type", null) === "photo";
    }

});
